import moment from 'moment';
import config from '../envConfig';

export const converterFormatoDataParaCamposDatePickerMobile = (data) => {
  if (!data) return "dd/mm/aaaa";

  return moment(data).format('DD/MM/YYYY');
}

export const calcularTempoRestanteDecursoPrazo = (data, decursoPrazo) => {
  if (data) {
    const hoje = moment(new Date()).startOf('day');
    const dataEnvio = moment(data).startOf('day'); // Outra data no passado
    const diferenca = moment.duration(hoje.diff(dataEnvio));

    const dias = diferenca.asDays();

    const diasRestantes = decursoPrazo - dias;

    return diasRestantes.toFixed(0);
  }
}
